var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import LeftTree from "./LeftTree.vue";
import RecordHeader from "./RecordHeader.vue";
import RecordTable from "./RecordTable.vue";
import AccoutCheckService from '../../../api/AccoutCheckService';
import GLOBAL_VUE from '../../../globalVue';
import { Loading } from 'element-ui';
var AccountRecord = (function (_super) {
    __extends(AccountRecord, _super);
    function AccountRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.detail = {
            shop_list: null
        };
        _this.total = 0;
        _this.filter = {};
        _this.treeClick = false;
        return _this;
    }
    AccountRecord.prototype.nodeClick = function (data) {
        this.$refs.pagination.clear();
        this.treeClick = true;
        delete this.filter.shop_ids;
        this.getList(data, true);
    };
    AccountRecord.prototype.getList = function (detail, isGetShopList, isShowLoading) {
        var _this = this;
        if (detail === void 0) { detail = {}; }
        if (isGetShopList === void 0) { isGetShopList = false; }
        if (isShowLoading === void 0) { isShowLoading = true; }
        var loadingInstance;
        if (isShowLoading) {
            loadingInstance = Loading.service({ fullscreen: true });
        }
        var business_id = detail.business_id ? detail.business_id : this.detail.business_id;
        var supplier_to_business_id = detail.supplier_to_business_id ? detail.supplier_to_business_id : this.detail.supplier_to_business_id;
        if (0 !== business_id && undefined !== business_id && isGetShopList) {
            this.service.getShopList(business_id, supplier_to_business_id).then(function (res) {
                _this.detail.shop_list = res.data.data || [];
                _this.detail.shop_ids = _this.filter.shop_ids || "-1";
            });
        }
        console.log('1111', business_id);
        this.service.getRecordList(Object.assign({
            business_id: detail.business_id || this.detail.business_id,
            supplier_to_business_id: detail.supplier_to_business_id || this.detail.supplier_to_business_id,
            shop_ids: "-1",
        }, this.$refs.pagination.pager, detail.business_id ? {} : this.filter)).then(function (res) {
            if (isShowLoading) {
                loadingInstance.close();
            }
            _this.detail = Object.assign({}, _this.detail || {}, __assign({}, detail), res.data.data);
            _this.total = res.data.total;
            if (_this.detail.statement_type === 10) {
                _this.detail.shop_list = _this.detail.receivable_list && _this.detail.receivable_list.length ? _this.detail.receivable_list[0].shop_list : [];
                if (_this.detail.shop_list.length) {
                    var shopList = _this.detail.shop_list.map(function (item) {
                        return {
                            shop_name: item.name,
                            shop_id: item.value
                        };
                    });
                    _this.detail.shop_list = shopList;
                }
                _this.detail.shop_ids = _this.filter.shop_ids || "-1";
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            if (isShowLoading) {
                loadingInstance.close();
            }
        });
    };
    AccountRecord.prototype.headerChange = function (filter) {
        this.treeClick = false;
        if (!filter.account_date_start || !filter.account_date_end)
            return;
        if (filter.account_date_start) {
            filter.account_date_start = filter.account_date_start.format('yyyy-MM-dd');
        }
        if (filter.account_date_end) {
            filter.account_date_end = filter.account_date_end.format('yyyy-MM-dd');
        }
        delete filter.shop;
        this.filter = filter;
        this.$refs.pagination.clear();
        this.getList({}, false, false);
    };
    AccountRecord.prototype.pageChange = function (pager) {
        this.getList();
    };
    AccountRecord.prototype.addTab = function (options) {
        options.opener = this;
        GLOBAL_VUE.$emit('addTab', options);
    };
    AccountRecord.prototype.created = function () {
        this.service = AccoutCheckService.getInstance();
    };
    AccountRecord = __decorate([
        Component({
            components: {
                "left-tree": LeftTree,
                "record-header": RecordHeader,
                "record-table": RecordTable
            },
            computed: {
                isHideUnAmount: function () {
                    return (this.detail.statement_order_money_only_manual_entry - 0) === 1;
                }
            }
        })
    ], AccountRecord);
    return AccountRecord;
}(Vue));
export default AccountRecord;
